import React, { FunctionComponent } from 'react'
import Image from 'gatsby-image'
import classnames from 'classnames'
import { useStaticQuery, graphql, Link } from 'gatsby'

import { File } from '../../graphql-types'

const Styles = require('./Header.module.styl')

type Props = {
  headerCls?: string
}

type GQLProps = {
  avatar: File
}

export const Header: FunctionComponent<Props> = props => {

  const data = useStaticQuery<GQLProps>(graphql`
    query HeaderQuery {
      avatar: file(absolutePath: { regex: "/logo.png/" }) {
        childImageSharp {
          fixed(width: 45, height: 45) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)

  return (
    <div className={Styles['container']}>
      <div className={classnames(Styles['header'], props.headerCls)}>
        <div className={Styles['logo']}>
          <Link className={Styles['home']} to='/'>
            <Image fixed={data.avatar.childImageSharp.fixed} alt={'icon'} />
          </Link>
        </div>
        <div className={Styles['navbar']}>
          <Link activeClassName={Styles['active']} to='/posts' className={Styles['item']}>
            <i className='iconfont'>&#xe64f;</i>
            <span className={Styles['title']}>首页</span>
          </Link>
          <Link activeClassName={Styles['active']} to='/tags' className={Styles['item']}>
            <i className='iconfont'>&#xe63e;</i>
            <span className={Styles['title']}>标签</span>
          </Link>
          <Link partiallyActive={true} activeClassName={Styles['active']} to='/series' className={Styles['item']}>
            <i className='iconfont'>&#xe898;</i>
            <span className={Styles['title']}>系列</span>
          </Link>
          <a className={Styles['item']} href='https://github.com/MLuminary' target='_blank' rel='noopener noreferrer'>
            <i className='iconfont'>&#xe716;</i>
            <span className={Styles['title']}>GitHub</span>
          </a>
          <Link activeClassName={Styles['active']} to='/about' className={Styles['item']}>
            <i className='iconfont'>&#xe604;</i>
            <span className={Styles['title']}>关于</span>
          </Link>
        </div>
      </div>
    </div>
  )
}
